var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHamburger = function SvgHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M19.375 6.25a4.375 4.375 0 1 0 0 8.75 4.375 4.375 0 0 0 0-8.75M12.5 10.625a6.875 6.875 0 1 1 12.54 3.896l3.344 3.345-1.768 1.768-3.343-3.344A6.875 6.875 0 0 1 12.5 10.625M3.75 5H10v2.5H3.75zm0 8.75H10v2.5H3.75zm22.5 8.75V25H3.75v-2.5z"
  })));
};
export default SvgHamburger;